const validate = {
  rules: {
    titulo: {
      required: true,
    },
    texto: {
      required: true,
    },
    endereco: {
      required: true,
    },
    missao: {
      required: true,
    },
    visao: {
      required: true,
    },
    valores: {
      required: true,
    },
  },
  messages: {
    titulo: "O título é obrigatório.",
    texto: "O texto é obrigatório.",
    endereco: "O endereço é obrigatório.",
    missao: "A missão é obrigatória.",
    visao: "A visão é obrigatória.",
    valores: "Os valores são obrigatórios.",
  },
};

export default validate;
